<template>
    <div class="accordion">
        <slot></slot>
    </div>
</template>
<script lang="ts" setup></script>
